import { render, staticRenderFns } from "./shuttleResult.vue?vue&type=template&id=2d196e56&scoped=true&"
import script from "./shuttleResult.vue?vue&type=script&lang=js&"
export * from "./shuttleResult.vue?vue&type=script&lang=js&"
import style0 from "./shuttleResult.vue?vue&type=style&index=0&id=2d196e56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d196e56",
  null
  
)

export default component.exports